/** Map plan names to number */
const planMapping = {
	free: 0,
	deluxe: 20,
} as const;

export default planMapping;
